import * as React from 'react';
import { IconButton } from '@cian/ui-kit';
import { IconActionClose16 } from '@cian/ui-kit-design-tokens/icons';

export interface IFullScreenGalleryCloseButtonProps {
  onClick(): void;
}

export function CloseButton({ onClick }: IFullScreenGalleryCloseButtonProps): React.JSX.Element {
  return (
    <IconButton
      aria-label="Закрыть"
      data-testid="FullscreenGalleryCloseButton"
      icon={<IconActionClose16 />}
      onClick={onClick}
    />
  );
}
